$(document).ready(function() {

  var mySwiper = new Swiper('.swiper-container', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    autoplay: 3000,
    autoplayDisableOnInteraction: true,
    pagination: '.swiper-pagination',
  });

  var sub_header_height =
    $('#sub-header-text-section').height() +
    parseInt($('#sub-header-text-section').css('marginTop')) * 2;
  var main_header_height =
    $(window).height() -
    sub_header_height -
    parseInt($('.main-header').css('margin-top'));
  $('.main-header').height(main_header_height);

  squareBoxCategorySubclasses();
  if ($(window).width() < 1200 || $('nav').hasClass('nav-fullscreen')) {
    positionSubNavDesktop(true);
  } else {
    positionSubNavDesktop();
  }
  $('#product-class .box-category').on('click tap', function(e) {
    var $this = $(this);
    if ($(window).width() < 1100) {
      if (!$this.hasClass('open-box')) {
        e.preventDefault();
      }

      console.log('add Open');

      $('#product-class .box-category').each(function() {
        if ($(window).width() < 768) {
          $(this).removeClass('open-mobile');
          $(this).height(heightCategoryBoxTitle);
        }

        $(this).removeClass('open-box');
      });
      $this.addClass('open-box');
      $this.height($('#product-class .box-category').width());
    }
  });
});

$(window).on('resize', function() {
  squareBoxCategorySubclasses();

  positionSubNavDesktop();
});
const heightCategoryBoxTitle = 99;
function squareBoxCategorySubclasses() {
  var height = $('#product-class .box-category').width();
  if ($(window).width() < 768) {
    height = heightCategoryBoxTitle;
  }
  $('#product-class .box-category').each(function() {
    $(this).height(height);
  });
}

// $(document).on('scroll', function() {
//   if ($('nav').hasClass('nav-fullscreen') && !$('nav').hasClass('product')) {
//     if ($(document).scrollTop() < 200) {
//       //$('nav').removeClass('nav-fullscreen');
//       setTimeout(function() {
//         positionSubNavDesktop();
//       }, 350);
//     }
//     return;
//   }
//   if ($(document).scrollTop() > 200 && !$('nav').hasClass('product')) {
//     //$('nav').addClass('nav-fullscreen');
//     setTimeout(function() {

//       positionSubNavDesktop(true);
//     }, 350);
//   }
// });

var dropBox = '';
var $ancorLiNav = $();
var close_search_timeout;

$('.link-container-desktop li.dropdown').hover(
  function() {
    dropBox = $(this).data('dropdown');
    $ancorLiNav = $(this);

    close_search_timeout = setTimeout(function() {
      $('.search-container').removeClass('open');
      $('.back-black').fadeOut('fast');
    }, 200);

    $('nav .sub-nav ul').each(function() {
      $(this);
    });
    $ancorLiNav.addClass('hover');

    if ($ancorLiNav.hasClass('dropdown')) {
      $('nav .sub-nav ' + dropBox).addClass('active');
    }
  },
  function() {
    if (close_search_timeout) clearTimeout(close_search_timeout);

    $(this).removeClass('hover');
    dropBox = $(this).data('dropdown');
    $('nav .sub-nav ' + dropBox).removeClass('active');
  }
);

$('.sub-nav ul').hover(
  function() {
    $('nav .sub-nav ' + dropBox).addClass('active');
    $ancorLiNav.addClass('hover');
  },
  function() {
    $ancorLiNav.removeClass('hover');
    if ($('nav .sub-nav ' + dropBox).hasClass('active')) {
      if (!$('nav .sub-nav').hasClass('open')) {
        $('nav .sub-nav ' + dropBox).removeClass('active');
      }
    }
  }
);

// NAV MOBILE EVENT
$('nav .hamb-icon').on('click tap', function() {
  if ($(this).hasClass('open')) {
    $('.nav-collapse').removeClass('visible');
    $(this).attr('src', '/spike-compiled/img/icon/prima-automotive-hamb.png');
    $(this).removeClass('open');
  } else {
    $('.nav-collapse').addClass('visible');
    $(this).attr('src', '/spike-compiled/img/icon/prima-automotive-close.png');
    $(this).addClass('open');
  }
});

$('.nav-collapse .dropdown-mobile').on('click tap', function(e) {
  e.preventDefault();
  var $this = $(this);
  if ($this.hasClass('open')) {
    window.location = $(this)
      .children()
      .attr('href');
    $this.removeClass('open');
    $this.children('.dropdown-box').removeClass('open');
    $('.nav-collapse .link-list-nav-mobile').removeClass(
      'open-children-dropdown'
    );
    return;
  }
  $('.nav-collapse .dropdown-mobile').each(function() {
    $(this).removeClass('open');
    $(this)
      .children('.dropdown-box')
      .removeClass('open');
  });
  $this.addClass('open');
  $('.nav-collapse .link-list-nav-mobile').addClass('open-children-dropdown');
  $this.children('.dropdown-box').addClass('open');
});
$('.nav-collapse .dropdown-mobile .category-mobile').on('click tap', function(
  e
) {
  console.log(
    $(this)
      .children()
      .attr('href')
  );
  window.location = $(this)
    .children()
    .attr('href');
});

function positionSubNavDesktop(full) {
  $('.link-container-desktop li').each(function() {
    $li = $(this);
    var offsetLeft = $li.offset().left;
    var idDropdown = $li.data('dropdown');
    var liWidth = $li.width();
    var margin = 0;
    // if (!full) {
    //   margin = offsetLeft - 100 - 160 + liWidth / 2;
    // } else {
    margin = offsetLeft - 160 + liWidth / 2;
    // }
    // if ($(window).width() == ($('nav .nav-container').width() + 100))

    $('.sub-nav ' + idDropdown).css('margin-left', margin);
  });
}



//////////////////
// WEBPACK FOOTER
// ./assets/js/partials/_home.js
// module id = 9
// module chunks = 0